import React, { PureComponent } from 'react';
import './BSOD.css';

export default class BSOD extends PureComponent {
    render() {
        let dismiss = this.props.dismiss;

        return <div className="bsod" onClick={dismiss} onKeyPress={dismiss} onTouchEnd={dismiss}>
            <div className="inner">
                <div className="text">
                    <div className="header">Windows</div>
                    <div>
                        A fatal exception 0E has occurred at 002B:C00268ZZ in VXD VFAT(01) * 0000798E.
                        The current application will be terminated.
                    </div>
                    <div>
                        * Press any key to terminate the current application.<br/>
                        * Press CTRL+ALT+DEL again to restart your computer. You will lose any unsaved information in all applications.
                    </div>
                    <div className="press">Press any key to continue _</div>
                </div>
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/walleris/BSOD.js